import Vue from 'vue'
import Vuex from 'vuex'
import tab from './tab'
import sign from './sign'

Vue.use(Vuex)

//创建Vuex实例
export default new Vuex.Store({
  modules: {
    tab,
    sign,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js